import { MOBILE_SIZE_BREAKPOINT, SMALL_MOBILE_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import { TRACKS_Z_INDEX } from 'consts/zIndex'
import styled from 'styled-components'

export const Tracks = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  padding-top: 0;
  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    padding: 10px 20px;
  }
  @media (max-width: ${SMALL_MOBILE_SIZE_BREAKPOINT}px) {
    padding: 10px;
  }
`

export const TracksWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-grow: 1;
  z-index: ${TRACKS_Z_INDEX};
`

export const EmptyTrack = styled.div<{ $height: number }>`
  width: 100%;
  display: flex;
  align-items: center;
  height: ${({ $height }) => `${$height}px`};
  background-color: ${COLORS.primaryLight};
  border-radius: 4px;
  padding: 0 10px;
  margin-bottom: 6px;
`

// TODO: move to common-components if needed
export const ButtonWithIcon = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  gap: 8px;
  color: ${COLORS.secondarySemiDark};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  & svg {
    height: 18px;
    width: 18px;
    fill: ${COLORS.secondarySemiDark};
  }

  &:hover {
    color: ${COLORS.primaryDark};
    & svg {
      fill: ${COLORS.primaryDark};
    }
  }
`
